import React from "react";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import Header from "../components/Header.js";

function HelpAndroid() {
  return (
    <Translation>
      {t => (
        <div id="main">
          <Header />
          <div id="wrap">
            <div className="box">
              <h1>{t("android.setting_title")}</h1>
              <p>{t("android.introduction")}</p>
              <ol>
                <li>{t("android.setting_step_1")}</li>
                <li>{t("android.setting_step_2")}</li>
                <li>{t("android.setting_step_3")}</li>
                <li>{t("android.setting_step_4")}</li>
              </ol>
              <iframe
                width="315"
                height="560"
                src="https://www.youtube.com/embed/Tb7AUPmkWfE"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default HelpAndroid;
